export type SelectionTriggerEnum = 'Entity' | 'Property' | 'Ignore';
export const SelectionTriggerEnum = {
	Entity:   'Entity' as SelectionTriggerEnum,
	Property: 'Property' as SelectionTriggerEnum,
	Ignore:   'Ignore' as SelectionTriggerEnum
};
